import styled from "styled-components"
import { Link } from "react-router-dom"
import { mobilePortrait, smallScreen } from "../../Responsive"

export const Container = styled.div`
    background-color: ${({ theme }) => theme.body};
    display: flex;
    justify-content: space-between;

    min-height: 10vh;

    ${mobilePortrait({ flexDirection: "column" })}
`

export const Left = styled.div`
    flex: 1;
    display: flex;
    flex-direction: column;
    padding: 20px;
`

export const Logo = styled.h1`


    @media screen and (max-width: ${smallScreen}) {
        font-size: var(--fontM);
    }
`

export const Description = styled.p`
    margin: 20px 0px;

    @media screen and (max-width: ${smallScreen}) {
        font-size: var(--fontS);
    }
`

export const SocialContainer = styled.div`
    display: flex;
`

export const SocialIcon = styled.div`
    width: 24px;
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 20px;
    color: var(--secondary);
    cursor: pointer;
`

export const Center = styled.div`
    flex: 1;
    padding: 20px;
`

export const Title = styled.h3`
    margin-bottom: 30px;
`

export const List = styled.ul`
    margin: 0;
    padding: 0;
    list-style: none;
    display: flex;
    flex-wrap: wrap;
`

export const ListItem = styled.li`
    width: 50%;
    margin-bottom: 10px;
    font-size: var(--fontS);
`

export const StyledLink = styled(Link)`
    text-decoration: none;
    color: inherit;
    cursor: pointer;
`

export const Right = styled.div`
    flex: 1;
    padding: 20px;
    font-size: var(--fontS);
`

export const ContactItem = styled.div`
    margin-bottom: 10px;
    display: flex;
    align-items: center;
`

export const ContactIcon = styled.div`
    display: flex;
    align-items: center;
    margin-right: 10px;
    color: var(--secondary);
`
